function selectUpsellVariant(event, controlId) {
  const target = event.currentTarget;
  const swatchItems = target.parentElement.querySelectorAll('.upsell-swatch__item');
  swatchItems.forEach(item => item.classList.remove('is-active'));
  target.classList.add('is-active');
  const addToCartButton = document.getElementById(`${controlId}-upsell-add-to-cart`);
  if (addToCartButton) {
    addToCartButton.setAttribute('data-selected-variant-id', target.getAttribute('data-variant-id'));
    addToCartButton.setAttribute('data-selected-sku', target.getAttribute('data-variant-sku'));
  }
}

const customUpsellAddToInventory = async function (event, controlId) {

  const addToCartButton = event.currentTarget;

  try {
    const productItemElement = addToCartButton.closest("rid-product-item");
    const productType = productItemElement.getAttribute("data-product-type");
    const variantId = productItemElement.getAttribute(
      "data-selected-variant-id"
    );

    if (!variantId) {
      console.error("No variant ID found");
      return;
    }

    let variantImageSrc = null;
    variantImageSrc = productItemElement.getAttribute("data-variant-image-src");
    const productTitle = productItemElement.querySelector(
      ".product-item__title"
    );

    const inventoryContainer = document.querySelector(
      `#${controlId}-footer-inventory-container`
    );
    if (!inventoryContainer) {
      console.error("Inventory container not found");
      return;
    }

    if (inventoryContainer.classList.contains('is-visible') === false) {
      inventoryContainer.classList.add('is-visible');
    }

    const existingItem = inventoryContainer.querySelector(
      `[data-variant-id="${variantId}"]`
    );
    if (existingItem) {
      return;
    }

    const inventoryItem = document.createElement("div");
    inventoryItem.className = "inventory-item";
    inventoryItem.setAttribute("data-variant-id", variantId);
    inventoryItem.setAttribute("data-product-type", productType);
    inventoryItem.classList.add("is-hidden");

    inventoryItem.innerHTML = `
      <div class="inventory-item__image">
        <img src="${variantImageSrc}" alt="${
      productTitle ? productTitle.textContent.trim() : "Badge"
    }" width="40" height="40">
      </div>

      <button type="button" class="inventory-item__remove" onclick="removeFromInventory('${variantId}', '${controlId}')">×</button>
    `;
    inventoryContainer.prepend(inventoryItem);

    setTimeout(() => {
      inventoryItem.classList.remove("is-hidden");
    }, 200);

    const containerAddToCartButton = document.querySelector(
      `#${controlId}-upsell-add-to-cart`
    );
    const itemCount =
      inventoryContainer.querySelectorAll(".inventory-item").length;

    if (itemCount === 0) {
      containerAddToCartButton.textContent = "Add from Above";
      containerAddToCartButton.setAttribute("disabled", "true");
    } else {
      containerAddToCartButton.removeAttribute("disabled");
      containerAddToCartButton.textContent = `Add ${itemCount} item${
        itemCount > 1 ? "s" : ""
    } to ID`;
    }
  } catch (error) {
    console.error("Error adding to inventory:", error);
  }
};

// Function to remove item from inventory
function removeFromInventory(variantId, controlId) {
  const inventoryContainer = document.querySelector(
    `#${controlId}-footer-inventory-container`
  );
  const item = inventoryContainer.querySelector(
    `[data-variant-id="${variantId}"]`
  );

  if (item) {
    item.remove();

    const containerAddToCartButton = document.querySelector(
      `#${controlId}-upsell-add-to-cart`
    );
    const itemCount =
      inventoryContainer.querySelectorAll(".inventory-item").length;

    if (itemCount === 0) {
      containerAddToCartButton.textContent = "Add from Above";
      containerAddToCartButton.setAttribute("disabled", "true");
    } else {
      containerAddToCartButton.removeAttribute("disabled");
      containerAddToCartButton.textContent = `Add ${itemCount} item${
        itemCount > 1 ? "s" : ""
      } to ID`;
    }
  }

  const remainingItems =
    inventoryContainer.querySelectorAll(".inventory-item").length;

  if (remainingItems === 0) {
    inventoryContainer.classList.remove('is-visible');
  }
}

const customUpsellAddToCart = async function (event) {

  const addToCartButton = event.currentTarget;
  const selectedVariantId = addToCartButton.getAttribute(
    "data-selected-variant-id"
  );
  const selectedSku = addToCartButton.getAttribute(
    "data-selected-sku"
  );
  const originalText = addToCartButton.textContent;
  const builderId = addToCartButton.getAttribute("data-attribute-builder-id");

  addToCartButton.setAttribute("disabled", "true");
  addToCartButton.setAttribute("aria-busy", "true");
  addToCartButton.textContent = "ADDING TO ID...";
  try {
    const existingBundleItems = getExistingBundleItems(builderId);

    await clearPreviousContents(existingBundleItems);

    const newItem = {
      id: selectedVariantId,
      quantity: 1,
      properties: {
        "_builder-id": builderId,
        "_upsell-source": "cart",
      },
      product_type: addToCartButton.getAttribute("data-product-type") || "Unknown",
      sku: selectedSku || "",
    };

    const items = [...existingBundleItems, newItem];

    const sortedItems = sortBundleItems(items);

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: sortedItems,
      }),
    });

    const responseJson = await response.json();

    if (response.ok) {
      addToCartButton.style.backgroundColor = "#f4633a";
      addToCartButton.style.opacity = "1";
      addToCartButton.textContent = `Added to ID!`;
      const searchParams = new URLSearchParams(window.location.search);
      window.location.href = `${window.Shopify.routes.root}cart?${searchParams.toString()}`;
    } else {
      console.error("Failed to add item to cart:", responseJson);
      addToCartButton.textContent = "ERROR - TRY AGAIN";
      setTimeout(() => {
        addToCartButton.textContent = originalText;
        addToCartButton.removeAttribute("disabled");
        addToCartButton.removeAttribute("aria-busy");
      }, 2000);
    }
  } catch (error) {
    console.error("Error in customUpsellAddToCart:", error);
    addToCartButton.textContent = "ERROR - TRY AGAIN";
    setTimeout(() => {
      addToCartButton.textContent = originalText;
      addToCartButton.removeAttribute("disabled");
      addToCartButton.removeAttribute("aria-busy");
    }, 2000);
  }
};

const customInventoryAddToCart = async function (event, controlId) {

  const addToCartButton = event.currentTarget;
  const originalText = addToCartButton.textContent;
  const builderId = addToCartButton.getAttribute("data-attribute-builder-id");

  addToCartButton.setAttribute("disabled", "true");
  addToCartButton.setAttribute("aria-busy", "true");
  addToCartButton.textContent = "ADDING TO ID...";

  try {
    // Find all inventory items
    const inventoryContainer = document.querySelector(
      `#${controlId}-footer-inventory-container`
    );
    const inventoryItems = inventoryContainer.querySelectorAll(
      ".inventory-item[data-variant-id]"
    );

    if (inventoryItems.length === 0) {
      // No items in inventory, just navigate to cart
      const searchParams = new URLSearchParams(window.location.search);
      window.location.href = `${window.Shopify.routes.root}cart?${searchParams.toString()}`;
      return;
    }

    const productDisplayName = inventoryItems.length > 1 ? `items` : 'item';

    const existingBundleItems = getExistingBundleItems(builderId);

    await clearPreviousContents(existingBundleItems);

    // Build items array for batch add
    const newItems = Array.from(inventoryItems).map((item) => {
      const variantId = item.getAttribute("data-variant-id");
      return {
        id: variantId,
        quantity: 1,
        properties: {
          "_builder-id": builderId,
          "_upsell-source": "cart",
        },
        product_type: item.getAttribute("data-product-type") || "Unknown",
        sku: item.getAttribute("data-variant-sku") || "",
      };
    });

    // combined with existingBundleItems to ensure order
    const items = [...newItems, ...existingBundleItems];

    const sortedItems = sortBundleItems(items);

    // Use batch add endpoint
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: sortedItems }),
    });

    const responseJson = await response.json();

    if (response.ok) {


      // append items added message to url as query param = cart_notification= "3 badges added" for example
      const itemCount = inventoryItems.length;

      addToCartButton.style.backgroundColor = "#f4633a";
      addToCartButton.style.opacity = "1";
      addToCartButton.textContent = `Added ${itemCount} ${productDisplayName} to ID!`;

      // Navigate to cart page
      const searchParams = new URLSearchParams(window.location.search);
      window.location.href = `${window.Shopify.routes.root}cart?${searchParams.toString()}`;

    } else {
      console.error("Failed to add items to cart:", responseJson);
      addToCartButton.textContent = "ERROR - TRY AGAIN";

      // Reset button after delay
      setTimeout(() => {
        addToCartButton.textContent = originalText;
        addToCartButton.removeAttribute("disabled");
        addToCartButton.removeAttribute("aria-busy");
      }, 2000);
    }
  } catch (error) {
    console.error("Error in customInventoryAddToCart:", error);
    addToCartButton.textContent = "ERROR - TRY AGAIN";

    // Reset button after delay
    setTimeout(() => {
      addToCartButton.textContent = originalText;
      addToCartButton.removeAttribute("disabled");
      addToCartButton.removeAttribute("aria-busy");
    }, 2000);
  }
};

const getExistingBundleItems = (builderId) => {
  return window.cartItems.filter(item => item.properties["_builder-id"] === builderId);
};

const sortBundleItems = (items) => {

  const membershipProduct = items.find(item => item.product_type === 'Membership');
  const onlineProfileFreeYears = membershipProduct ? membershipProduct.sku.split('-').pop() : null;
  const onlineProfileFreeMonths = onlineProfileFreeYears ? parseInt(onlineProfileFreeYears) * 12 : null;
  
  const idItem = items.find(item => item.product_type === 'ID');

  if (idItem && onlineProfileFreeMonths) {
    idItem.properties["_online-profile-free-months"] = onlineProfileFreeMonths.toString();
  } else if (idItem && !onlineProfileFreeMonths) {
    let onlineProfileFreeMonthsProperty = idItem.properties["_online-profile-free-months"];
    if (onlineProfileFreeMonthsProperty) {  
      delete idItem.properties["_online-profile-free-months"];
    }
  }

  const priority = {
    'Badge': 1,
    'Band': 2,
    'Membership': 3,
    'Insurance': 4,
    'ID': 5
  };

  let returnedItems = items.sort((a, b) => {
    const aPriority = priority[a.product_type] || 5;
    const bPriority = priority[b.product_type] || 5;
    return aPriority - bPriority;
  });
  return returnedItems;
};

const clearPreviousContents = async function (lineItems) {
  const updates = {};
  lineItems.forEach(item => {
    updates[item.key] = 0;
  });

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    });
    const responseJson = await response.json();

    if (!response.ok) {
      console.error("Error clearing previous contents:", responseJson);
    }
  } catch (error) {
    console.error("Error clearing previous contents:", error);
  }
};

const onRemoveMembership = async function (event, key, builderId) {
  event.preventDefault();
  event.stopPropagation();

  toggleButtonState(event.target, true);
  event.target.textContent = "Removing...";

  const response = await fetch(window.Shopify.routes.root + "cart.js");
  const cart = await response.json();

  try {
    let existingBundleItems = getExistingBundleItems(builderId);
    await clearPreviousContents(existingBundleItems);

    const membershipItem = cart.items.find(item => item.key === key);

    if (membershipItem) {
      existingBundleItems = existingBundleItems.filter(item => item.key !== key);
      const idItem = existingBundleItems.find(item => item.product_type === 'ID');
      if (idItem) {
        let onlineProfileFreeMonthsProperty = idItem.properties["_online-profile-free-months"];
        if (onlineProfileFreeMonthsProperty) {
          delete idItem.properties["_online-profile-free-months"];
        }
      }
      const sortedItems = sortBundleItems(existingBundleItems);
      const updateResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: sortedItems }),
      });
      const updateResponseJson = await updateResponse.json();
      if (!updateResponse.ok) {
        console.error("Error updating cart:", updateResponseJson);
      }
    }
  } catch (error) {
    console.error("Error removing membership:", error);
  } finally {
    window.location.reload();
  }
};

const customAddToCart = async function (event, preorderDate) {
  const addToCartButton = document.getElementById("AddToCart");
  addToCartButton.setAttribute("disabled", "true");
  addToCartButton.setAttribute("aria-busy", "true");

  try {
    const variantIdElement = document.querySelector("input[name='id']");
    const variantId = variantIdElement ? variantIdElement.value : null;

    const quantityElement = document.querySelector("input[name='quantity']");
    const quantity = quantityElement ? quantityElement.value || 1 : 1;

    let body = {
      quantity: quantity,
      id: variantId,
    };

    if (preorderDate) {
      body.properties = {
        "_preorder-date": preorderDate,
      };
    }

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const responseJson = await response.json();

    if (response.ok) {
      if (
        window.themeVariables.settings.cartType === "page" ||
        window.themeVariables.settings.pageType === "cart"
      ) {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent("variant:added", {
          bubbles: true,
          detail: {
            variant: responseJson.hasOwnProperty("items")
              ? responseJson["items"][0]
              : responseJson,
          },
        })
      );

      const cartResponse = await fetch(
        `${window.themeVariables.routes.cartUrl}.js`
      );
      const cartContent = await cartResponse.json();
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: cartContent },
        })
      );

      // TH 12-4-24 issues with && !document.querySelector(".drawer") as to openMiniCart on DOGiD, maintaining change here
      cartContent["sections"] = responseJson["sections"];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart: window.themeVariables.settings.cartType === "drawer",
          },
        })
      );
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: response.ok ? "success" : "error",
          error: responseJson["description"] || "",
        },
      })
    );
  } finally {
    addToCartButton.removeAttribute("disabled");
    addToCartButton.setAttribute("aria-busy", "false");
  }
};

function toggleButtonState(target, isDisabled) {
  if (isDisabled) {
    target.setAttribute("disabled", "true");
    target.setAttribute("aria-disabled", "true");
    target.setAttribute("aria-busy", "true");
    target.classList.add("is-disabled");
  } else {
    target.removeAttribute("disabled");
    target.setAttribute("aria-disabled", "false");
    target.setAttribute("aria-busy", "false");
    target.classList.remove("is-disabled");
  }
}

function smoothScrollTo(event, targetId) {
  event.preventDefault();
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: "smooth" });
  }
}

// js/custom-element/ui/rid-native-video.js
// Extends Focal's native-video with autoplay failure fallback.
// When autoplay is blocked, falls back to poster + play button if a
// .video-wrapper__poster is present, otherwise toggles banner sections
// via data-section-id (rid-video-banner pattern).
var RidNativeVideo = class extends HTMLElement {
  constructor() {
    super();
    this.hasLoaded = false;
    if (this.autoPlay) {
      this.play();
    } else {
      this.addEventListener("click", this.play.bind(this), { once: true });
    }
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  play() {
    if (!this.hasLoaded) {
      this._replaceContent();
    }
    this.querySelector("video")
      .play()
      .then(() => {
        // Autoplay succeeded - hide poster if present
        var poster = this.querySelector(".video-wrapper__poster");
        if (poster) {
          poster.style.display = "none";
          this._announceState("Video is now playing");
        }
      })
      .catch((error) => {
        console.warn("Autoplay blocked, falling back", error);
        this._handleAutoplayFailure();
      });
  }
  pause() {
    if (this.hasLoaded) {
      this.querySelector("video").pause();
    }
  }
  // TH 3/11/26 - poster fallback for autoplay failure
  // Banner sections (rid-video-banner, rid-video-banner-deluxe, rid-video-with-text)
  // use data-section-id + enabled/disabled section toggles. Poster-only fallback
  // is for sections without that pattern (e.g. promotion-blocks).
  _handleAutoplayFailure() {
    // If this element uses the banner section toggle pattern, prefer that
    if (this.getAttribute("data-section-id")) {
      this._showHideEnabledDisabledAutoplaySections();
      return;
    }
    var poster = this.querySelector(".video-wrapper__poster");
    if (poster) {
      // Show poster and let user click play button to start video
      poster.style.display = "";
      var playButton = poster.querySelector(".video-wrapper__play-button");
      var target = playButton || poster;
      target.addEventListener("click", () => {
        this.querySelector("video").play().then(() => {
          poster.style.display = "none";
          this._announceState("Video is now playing");
        }).catch(() => {});
      }, { once: true });
      if (playButton) playButton.focus();
      return;
    }
    // Last resort - try section toggle anyway
    this._showHideEnabledDisabledAutoplaySections();
  }
  _announceState(message) {
    var el = this.querySelector(".video-wrapper__sr-status");
    if (!el) {
      el = document.createElement("span");
      el.className = "video-wrapper__sr-status visually-hidden";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
      this.appendChild(el);
    }
    el.textContent = message;
  }
  _showHideEnabledDisabledAutoplaySections() {
    var screenWidth = window.innerWidth;
    var isMobile = screenWidth <= 740;
    var sectionId = this.getAttribute("data-section-id");
    if (!sectionId) return;

    var findSections = function(pattern) {
      var enabled = document.getElementById(
        "video-banner-autoplay-enabled-section-" + pattern + "-" + sectionId
      );
      var disabled = document.getElementById(
        "video-banner-autoplay-disabled-section-" + pattern + "-" + sectionId
      );
      return { enabled: enabled, disabled: disabled };
    };

    var sections = findSections(isMobile ? "mobile" : "desktop");
    if (!sections.enabled || !sections.disabled) {
      sections = findSections("");
    }

    if (!sections.enabled || !sections.disabled) {
      console.warn("Autoplay fallback sections not found for section ID:", sectionId);
      return;
    }

    sections.enabled.style.display = "none";
    sections.disabled.style.display = "block";
  }

  _replaceContent() {
    var node = this.querySelector("template");
    if (!node) {
      return;
    }
    node = node.content.firstElementChild.cloneNode(true);
    if (!this.hasAttribute("autoplay")) {
      this.innerHTML = "";
    }
    this.appendChild(node);
    node.addEventListener("play", () => {
      this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
    });
    node.addEventListener("pause", () => {
      this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
    });
    this.hasLoaded = true;
  }
};
window.customElements.define("rid-native-video", RidNativeVideo);

// js/custom-element/ui/rid-order-now.js
var RidOrderNow = class extends HTMLElement {
  constructor() {
    super();
    this.preorderDate = this.getAttribute("data-pre-order-date");
    this.orderNowTextData = document.getElementById("order-now-text-data");
    this.presetText = this.orderNowTextData?.getAttribute(
      "data-order-now-text"
    );
    this.init();
  }

  async init() {
    // Find both text elements - we need to handle both regular and mini-cart versions
    this.textElements = [
      this.querySelector("#order-now-snippet-text"),
      this.querySelector("#order-now-mini-cart-snippet-text"),
    ].filter(Boolean); // Remove any null elements

    if (this.textElements.length === 0) {
      console.error("No order now text elements found");
      return;
    }

    if (this.preorderDate) {
      this.handlePreorderDate();
    } else if (this.presetText) {
      this.handlePresetText();
    } else {
      await this.handleDynamicShipping();
    }
  }

  handlePreorderDate() {
    const [year, month, day] = this.preorderDate.split("-");
    const dateObj = new Date(year, month - 1, day);
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = dateObj.toLocaleDateString("en-US", options);

    const text = `Order now and it ships <b>${formattedDate}.</b>`;
    this.updateAllTextElements(text);

    const fastMessage = this.querySelector("#get-it-fast-message");
    if (fastMessage) {
      fastMessage.style.display = "none";
    }

    // if preorder date is after 12/19/25 hide #additional-order-now-text - re: holiday messaging.
    const additionalText = this.querySelector("#additional-order-now-text");
    const cutOffDate = new Date(2025, 11, 19);
    if (additionalText && dateObj > cutOffDate) {
      additionalText.style.display = "none";
    }

    this.style.opacity = "1";
  }

  handlePresetText() {
    this.updateAllTextElements(this.presetText);
    this.style.opacity = "1";
  }

  async handleDynamicShipping() {
    try {
      const response = await fetch(
        "https://roadid.com/pages/shipping_date_v2.json"
      );
      const responseJson = await response.json();
      const data = JSON.parse(responseJson.page.body_html.replace(/'/g, '"'));

      const now = new Date();
      const cutoffDateTime = new Date(data.cutoffDateTime);
      let shipsWhen;
      let expectedShipDate;

      if (now < cutoffDateTime) {
        expectedShipDate = new Date(data.preCutoffShipDate);
      } else {
        expectedShipDate = new Date(data.postCutoffShipDate);
      }

      const normalizeDate = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      };

      const normalizedExpectedShipDate = normalizeDate(expectedShipDate);
      const normalizedNow = normalizeDate(now);
      const dayDifference = Math.ceil(
        (normalizedExpectedShipDate - normalizedNow) / (1000 * 60 * 60 * 24)
      );

      if (dayDifference === 0) {
        shipsWhen = "today";
      } else if (dayDifference === 1) {
        shipsWhen = "tomorrow";
      } else if (dayDifference > 6) {
        shipsWhen = `in ${dayDifference} days`;
      } else {
        shipsWhen = expectedShipDate.toLocaleString("en-US", {
          weekday: "long",
        });
      }

      const timeDifferenceMs = cutoffDateTime - now;
      const remainingHours = Math.floor(timeDifferenceMs / (1000 * 60 * 60));
      const remainingMinutes = Math.floor(
        (timeDifferenceMs % (1000 * 60 * 60)) / (1000 * 60)
      );
      const isDeadlineApproaching = remainingHours < 6;

      let text =
        isDeadlineApproaching === false
          ? `Order <b>now</b> and it ships <b>${shipsWhen}!</b>`
          : remainingHours > 0 || remainingMinutes > 0
          ? `Order within <b>${
              remainingHours > 0
                ? `${remainingHours} ${remainingHours === 1 ? "hour" : "hours"}`
                : ""
            } ${
              remainingMinutes > 0
                ? `${remainingMinutes} ${
                    remainingMinutes === 1 ? "minute" : "minutes"
                  }`
                : ""
            }</b> and it ships <b>${shipsWhen}!</b>`
          : `Order now and it ships <b>${shipsWhen}!</b>`;

      if (this.orderNowTextData) {
        this.orderNowTextData.setAttribute("data-order-now-text", text);
      }

      this.updateAllTextElements(text);
      this.style.opacity = "1";
    } catch (e) {
      console.error("Error fetching shipping information:", e);
    }
  }

  updateAllTextElements(text) {
    this.textElements.forEach((element) => {
      element.innerHTML = text;
    });
  }
};

window.customElements.define("rid-order-now", RidOrderNow);



// js/custom-element/section/product/rid-product-media.js
var RidProductMedia = class extends CustomHTMLElement {
  async connectedCallback() {
    this.mainCarousel = this.querySelector("flickity-carousel");
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
    if (this.mainCarousel.childElementCount === 1) {
      return;
    }
    this.selectedVariantMediaId = null;
    this.viewInSpaceElement = this.querySelector("[data-shopify-model3d-id]");
    this.zoomButton = this.querySelector(".product__zoom-button");
    this.product = await ProductLoader.load(
      this.getAttribute("product-handle")
    );
    const form = document.getElementById(this.getAttribute("form-id"));
    form?.addEventListener("variant:change", this._onVariantChanged.bind(this));
    this.mainCarousel.addEventListener("model:played", () =>
      this.mainCarousel.setDraggable(false)
    );
    this.mainCarousel.addEventListener("model:paused", () =>
      this.mainCarousel.setDraggable(true)
    );
    this.mainCarousel.addEventListener("video:played", () =>
      this.mainCarousel.setDraggable(false)
    );
    this.mainCarousel.addEventListener("video:paused", () =>
      this.mainCarousel.setDraggable(true)
    );
    this.mainCarousel.addEventListener(
      "flickity:ready",
      this._onFlickityReady.bind(this)
    );
    this.mainCarousel.addEventListener(
      "flickity:slide-changed",
      this._onFlickityChanged.bind(this)
    );
    this.mainCarousel.addEventListener(
      "flickity:slide-settled",
      this._onFlickitySettled.bind(this)
    );
    this._onFlickityReady();
  }
  get thumbnailsPosition() {
    return window.matchMedia(window.themeVariables.breakpoints.pocket).matches
      ? "bottom"
      : this.getAttribute("thumbnails-position");
  }
  async _setupVisibility() {
    await this.untilVisible();
    const flickityInstance = await this.mainCarousel.flickityInstance,
      image = flickityInstance
        ? flickityInstance.selectedElement.querySelector("img")
        : this.querySelector(".product__media-image-wrapper img"),
      prefersReducedMotion = MediaFeatures.prefersReducedMotion();
    await imageLoaded(image);
    const animation = new CustomAnimation(
      new ParallelEffect([
        new CustomKeyframeEffect(
          image,
          {
            opacity: [0, 1],
            transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"],
          },
          { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }
        ),
        new ParallelEffect(
          Array.from(
            this.querySelectorAll(".product__thumbnail-item:not(.is-filtered)")
          ).map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform:
                  this.thumbnailsPosition === "left"
                    ? [
                        `translateY(${prefersReducedMotion ? 0 : "40px"})`,
                        "translateY(0)",
                      ]
                    : [
                        `translateX(${prefersReducedMotion ? 0 : "50px"})`,
                        "translateX(0)",
                      ],
              },
              {
                duration: 250,
                delay: prefersReducedMotion ? 0 : 100 * index,
                easing: "cubic-bezier(0.75, 0, 0.175, 1)",
              }
            );
          })
        ),
      ])
    );
    this._hasSectionReloaded ? animation.finish() : animation.play();
  }
  async _onVariantChanged(event) {
    const variant = event.detail.variant;
    const featuredMediaId = event.detail.variant["featured_media"]
      ? event.detail.variant["featured_media"]["id"]
      : null;

    let allowedIds = [];
    if (featuredMediaId) allowedIds.push(featuredMediaId);

    const filteredMediaIds = [];
    let shouldReload = false;

    this.product["media"].forEach((media) => {
      let matchMedia2 =
        variant["featured_media"] &&
        media["id"] === variant["featured_media"]["id"];
      if (media["alt"]?.includes("#")) {
        shouldReload = true;
        if (!matchMedia2) {
          const altParts = media["alt"].split("#"),
            mediaGroupParts = altParts.pop().split("_");
          this.product["options"].forEach((option) => {
            if (
              option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()
            ) {
              if (
                variant["options"][option["position"] - 1].toLowerCase() !==
                mediaGroupParts[1].trim().toLowerCase()
              ) {
                filteredMediaIds.push(media["id"]);
              }
            }
          });
        }
      }
    });

    let currentlyFilteredIds = [
      ...new Set(
        Array.from(this.querySelectorAll(".is-filtered[data-media-id]")).map(
          (item) => parseInt(item.getAttribute("data-media-id"))
        )
      ),
    ];
    if (allowedIds.length > 0) {
      const selectedMediaId = variant["featured_media"]
        ? variant["featured_media"]["id"]
        : this.product["media"]
            .map((item) => item.id)
            .filter((item) => !filteredMediaIds.includes(item))[0];
      const flickityInstance = await this.mainCarousel.flickityInstance;
      flickityInstance.destroy();
      Array.from(this.querySelectorAll("[data-media-id]")).forEach((item) => {
        if (item.hasAttribute("is-featured-media")) {
          allowedIds.includes(parseInt(item.getAttribute("data-media-id"))) ||
            allowedIds.push(parseInt(item.getAttribute("data-media-id")));
        }
        item.classList.toggle(
          "is-filtered",
          !allowedIds.includes(parseInt(item.getAttribute("data-media-id")))
        );
        item.classList.toggle(
          "is-selected",
          selectedMediaId === parseInt(item.getAttribute("data-media-id"))
        );
        item.classList.toggle(
          "is-initial-selected",
          selectedMediaId === parseInt(item.getAttribute("data-media-id"))
        );
      });
      this.mainCarousel.reload();
    } else {
      if (
        !event.detail.variant["featured_media"] ||
        this.selectedVariantMediaId ===
          event.detail.variant["featured_media"]["id"]
      ) {
        return;
      }
      this.mainCarousel.select(
        `[data-media-id="${event.detail.variant["featured_media"]["id"]}"]`
      );
    }
    this.selectedVariantMediaId = event.detail.variant["featured_media"]
      ? event.detail.variant["featured_media"]["id"]
      : null;
  }
  async _onFlickityReady() {
    const flickityInstance = await this.mainCarousel.flickityInstance;
    if (
      ["video", "external_video"].includes(
        flickityInstance.selectedElement.getAttribute("data-media-type")
      ) &&
      this.hasAttribute("autoplay-video")
    ) {
      flickityInstance.selectedElement.firstElementChild.play();
    }
  }
  async _onFlickityChanged() {
    const flickityInstance = await this.mainCarousel.flickityInstance;
    flickityInstance.cells.forEach((item) => {
      if (
        ["external_video", "video", "model"].includes(
          item.element.getAttribute("data-media-type")
        )
      ) {
        item.element.firstElementChild.pause();
      }
    });
  }
  async _onFlickitySettled() {
    const flickityInstance = await this.mainCarousel.flickityInstance,
      selectedSlide = flickityInstance.selectedElement;
    if (this.zoomButton) {
      this.zoomButton.hidden =
        selectedSlide.getAttribute("data-media-type") !== "image";
    }
    if (this.viewInSpaceElement) {
      this.viewInSpaceElement.setAttribute(
        "data-shopify-model3d-id",
        this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id")
      );
    }
    switch (selectedSlide.getAttribute("data-media-type")) {
      case "model":
        this.viewInSpaceElement.setAttribute(
          "data-shopify-model3d-id",
          selectedSlide.getAttribute("data-media-id")
        );
        selectedSlide.firstElementChild.play();
        break;
      case "external_video":
      case "video":
        if (this.hasAttribute("autoplay-video")) {
          selectedSlide.firstElementChild.play();
        }
        break;
    }
  }
};
window.customElements.define("rid-product-media", RidProductMedia);

var RidProductList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".product-list__inner");
    this.productItems = Array.from(this.querySelectorAll("rid-product-item"));
  }
  connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this));
    this.addEventListener("prev-next:next", this.next.bind(this));
    if (!this.hidden && this.staggerApparition) {
      this._staggerProductsApparition();
    }
  }

  attributeChangedCallback(name) {
    if (name === "hidden") {
      if (this.staggerApparition && !this.hidden) {
        this._staggerProductsApparition();
      }
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  get apparitionAnimation() {
    return (this._animation =
      this._animation ||
      new CustomAnimation(
        new ParallelEffect(
          this.productItems.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: [
                  `translateY(${
                    MediaFeatures.prefersReducedMotion()
                      ? 0
                      : window.innerWidth < 1e3
                      ? 35
                      : 60
                  }px)`,
                  "translateY(0)",
                ],
              },
              {
                duration: 600,
                delay: MediaFeatures.prefersReducedMotion()
                  ? 0
                  : 100 * index - Math.min(3 * index * index, 100 * index),
                easing: "ease",
              }
            );
          })
        )
      ));
  }

  previous(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip -
        (this.productListInner.clientWidth + columnGap) <=
        0
    );
    this.productListInner.scrollBy({
      left: -(this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }

  next(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip +
        (this.productListInner.clientWidth + columnGap) * 2 >=
        this.productListInner.scrollWidth
    );
    this.productListInner.scrollBy({
      left: (this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  async _staggerProductsApparition() {
    this.productItems.forEach((item) => (item.style.opacity = 0));
    await this.untilVisible({
      threshold:
        this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
    });
    this.apparitionAnimation.play();
  }
};
__publicField(RidProductList, "observedAttributes", ["hidden"]);
window.customElements.define("rid-product-list", RidProductList);

var RidProductItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.primaryImageList = Array.from(
      this.querySelectorAll(".product-item__primary-image")
    );

    this.currentAnimation = null;

    // If CTA is configured as ATC, intercept delegated clicks on data-role="atc-button" elements
    this.delegate.on(
      'click',
      '[data-role="atc-button"]',
      (event, target) => {
        // Stop navigation from the wrapping anchor (if any)
        event.preventDefault();
        event.stopPropagation();
        this.addSelectedVariantToCart();
      }
    );

    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .color-swatch__radio",
      this._onColorSwatchChanged.bind(this)
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .block-swatch__radio",
      this._onColorSwatchChanged.bind(this)
    );

    // Initialize state based on any pre-selected swatches (e.g. from browser back navigation)
    this._initializeSwatchState();
  }

  _updateSwatchAvailability = function (
    bandVariants,
    selectedValues,
    matchingVariant,
    width = null
  ) {
    if (!bandVariants) return;
    let bandVariantsArr;
    try {
      bandVariantsArr = JSON.parse(bandVariants);
    } catch (e) {
      console.error("Failed to parse bandVariants", e);
      return;
    }

    if (width) {
      bandVariantsArr = bandVariantsArr.filter((variant) => {
        return (
          variant.option1 === width ||
          variant.option2 === width ||
          variant.option3 === width
        );
      });
      if (bandVariantsArr.length === 0) {
        console.warn("No band variants found for width:", width);
        return;
      }
    }

    const colorSwatchGroup = this.querySelector(
      '.swatch-group-wrapper[data-option-title="Color"]'
    );
    if (!colorSwatchGroup) return;

    colorSwatchGroup
      .querySelectorAll(".color-swatch__item")
      .forEach((swatch) => {
        const swatchValue = swatch.getAttribute("value");
        const swatchContainer = swatch.parentElement;
        const match = bandVariantsArr.find(
          (variant) =>
            variant.option1 === swatchValue ||
            variant.option2 === swatchValue ||
            variant.option3 === swatchValue
        );
        if (match && !match.available) {
          swatchContainer.classList.add("rid-product-item-swatch__unavailable");
        } else {
          swatchContainer.classList.remove(
            "rid-product-item-swatch__unavailable"
          );
        }
      });
  };

  async _onColorSwatchChanged(event, target) {
    let product = this;
    let variants = product.getAttribute("data-product-variants");
    let bandVariants = product.getAttribute("data-band-product-variants");
    let triggersAvailabilityCheck =
      target.getAttribute("triggers_availability_check") === "true" &&
      !!bandVariants;

    try {
      variants = JSON.parse(variants);
    } catch (e) {
      console.error(e);
      return;
    }
    let selectedValues = {};

    const swatchGroup = target.closest(".swatch-group-wrapper");

    if (swatchGroup) {
      swatchGroup.setAttribute(
        "data-selected-value",
        target.getAttribute("value")
      );

      swatchGroup
        .querySelectorAll(".color-swatch__item, .block-swatch__item")
        .forEach((swatch) => {
          swatch.classList.remove("is-selected");
        });

      target.classList.add("is-selected");
      const input = target
        .closest(".color-swatch, .block-swatch")
        ?.querySelector("input");
      if (input) {
        input.checked = true;
        input.focus();
      }
    }

    Array.from(this.querySelectorAll(".swatch-group-wrapper")).forEach(
      (swatchGroup) => {
        let count = 1;
        if (
          swatchGroup.getAttribute("data-option-name") ===
          target.getAttribute("data-option-name")
        ) {
          swatchGroup.setAttribute(
            "data-selected-value",
            target.getAttribute("value")
          );
        }
        selectedValues[swatchGroup.getAttribute("data-option-name")] =
          swatchGroup.getAttribute("data-selected-value") || "";
        count++;
      }
    );
    await this._findMatchingVariantAndSetRelated(
      target,
      selectedValues,
      variants,
      bandVariants,
      triggersAvailabilityCheck
    );
    return;
  }

  // Initialize component state based on pre-selected swatches
  _initializeSwatchState() {
    setTimeout(async () => {
      // Only run if at least one radio is checked (back-nav)
      const anyChecked = this.querySelector('input[type="radio"]:checked');
      if (!anyChecked) {
        return;
      }

      // Build selectedValues for option1/option2/option3 by inspecting swatch groups
      const selectedValues = {};
      const swatchGroups = this.querySelectorAll('.swatch-group-wrapper');

      swatchGroups.forEach((group) => {
        const optionName = group.getAttribute('data-option-name');
        if (!optionName) return;

        // Prefer a checked radio within the group
        let value = '';
        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked) {
          value = checked.value || checked.getAttribute('value') || '';
        }

        // Fallback to explicit data-selected-value stored on the group
        if (!value) {
          value = group.getAttribute('data-selected-value') || '';
        }

        // Final fallback: first swatch item value
        if (!value) {
          const firstSwatchItem = group.querySelector('.color-swatch__item, .block-swatch__item');
          if (firstSwatchItem) {
            value = firstSwatchItem.getAttribute('value') || '';
          }
        }

        selectedValues[optionName] = value || '';
      });

      // Parse variants and optional band variants for resolution
      let variants;
      try {
        variants = JSON.parse(this.getAttribute('data-product-variants'));
      } catch (e) {
        console.error('Failed to parse variants', e);
        return;
      }

      let bandVariants = this.getAttribute('data-band-product-variants');
      try {
        bandVariants = bandVariants ? JSON.parse(bandVariants) : null;
      } catch (e) {
        console.error('Failed to parse band variants', e);
        bandVariants = null;
      }

      await this._findMatchingVariantAndSetRelated(
        null,
        selectedValues,
        variants,
        bandVariants,
        false
      );
    }, 100);
  }

  async _findMatchingVariantAndSetRelated(target, selectedValues, variants, bandVariants = null, triggersAvailabilityCheck = false) {

    let matchingVariant = variants.find(variant => 
      variant.option1 === selectedValues['option1'] &&
      variant.option2 === selectedValues['option2'] &&
      variant.option3 === selectedValues['option3']
    ) || variants.find(variant => 
      variant.option1 === selectedValues['option1'] &&
      variant.option2 === selectedValues['option2']
    ) || variants.find(variant => 
      variant.option1 === selectedValues['option1']
    ) || variants[0];

    if (!matchingVariant) return;


    let matchingVariantId = matchingVariant
      ? matchingVariant.id
      : target.getAttribute("data-variant-id");

    this.setAttribute('data-selected-variant-id', matchingVariantId);

    // Update sold out badges and forms
    const soldOutBadge = this.querySelector("#rid-product-item-sold-out-badge");
    const upsellQuickForm = this.querySelector(".upsell-quick-form");
    const productQuickForm = this.querySelector(".product-item__quick-form");

    if (matchingVariant.available) {
      soldOutBadge?.style.setProperty("display", "none", "important");
      upsellQuickForm?.style.setProperty("visibility", "visible", "important");
      productQuickForm?.style.setProperty("visibility", "visible", "important");
    } else {
      upsellQuickForm?.style.setProperty("visibility", "hidden", "important");
      productQuickForm?.style.setProperty("visibility", "hidden", "important");
      soldOutBadge?.style.setProperty("display", "inline-block", "important");
    }

    Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
      let url;
      if (link.tagName === "A") {
        url = new URL(link.href);
      } else {
        url = new URL(
          link.getAttribute("href"),
          `https://${window.themeVariables.routes.host}`
        );
      }

      url.searchParams.set("variant", matchingVariantId);
      link.setAttribute("href", url.toString());
    });

    if (this.currentAnimation) {
      this.currentAnimation.cancel();
      this.currentAnimation = null;
    }

    const newImage = this.primaryImageList.find((image) => {
      const variantId = image.getAttribute("data-variant-id");
      return variantId === matchingVariantId.toString();
    });

    if (!newImage) {
      console.warn(
        "No matching image found for variant ID:",
        matchingVariantId
      );
      return;
    }

    newImage.setAttribute("loading", "eager");
    const onImageLoaded = newImage.complete
      ? Promise.resolve()
      : new Promise((resolve) => (newImage.onload = resolve));
    await onImageLoaded;
    newImage.removeAttribute("hidden");
    this.setAttribute("data-variant-image-src", newImage.src);
    let properties = {};
    if (
      Array.from(newImage.parentElement.classList).some((item) =>
        [
          "aspect-ratio--short",
          "aspect-ratio--tall",
          "aspect-ratio--square",
        ].includes(item)
      )
    ) {
      properties = [
        {
          clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
          transform: "translate(calc(-50% - 20px), -50%)",
          zIndex: 1,
          offset: 0,
        },
        {
          clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
          transform: "translate(calc(-50% - 20px), -50%)",
          zIndex: 1,
          offset: 0.3,
        },
        {
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          transform: "translate(-50%, -50%)",
          zIndex: 1,
          offset: 1,
        },
      ];
    } else {
      properties = [
        {
          clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
          transform: "translateX(-20px)",
          zIndex: 1,
          offset: 0,
        },
        {
          clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
          transform: "translateX(-20px)",
          zIndex: 1,
          offset: 0.3,
        },
        {
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          transform: "translateX(0px)",
          zIndex: 1,
          offset: 1,
        },
      ];
    }

    this.currentAnimation = newImage.animate(properties, {
      duration: 500,
      easing: "ease-in-out",
    });

    try {
      await this.currentAnimation.finished;
    } catch {
      // Animation was cancelled - this is expected when clicking rapidly
    }

    this.primaryImageList
      .filter(
        (image) =>
          image.classList.contains("product-item__primary-image") &&
          image !== newImage
      )
      .forEach((image) => image.setAttribute("hidden", ""));
    triggersAvailabilityCheck &&
      this._updateSwatchAvailability(
        bandVariants,
        selectedValues,
        matchingVariant,
        target.getAttribute("value")
      );
  }
  
  // Add currently selected variant to cart (used when CTA is configured as ATC)
  async addSelectedVariantToCart() {
    try {
      const ridProductItemId = this.getAttribute('id') || 'unknown';
      const variantIdAttr = this.getAttribute('data-selected-variant-id');
      let variantId = variantIdAttr || null;

      if (!variantId) {
        const visibleImage = this.primaryImageList.find(img => !img.hasAttribute('hidden')) || this.primaryImageList[0];
        variantId = visibleImage ? visibleImage.getAttribute('data-variant-id') : null;
      }

      if (!variantId) {
        console.error('RidProductItem: No selected variant id found for ATC CTA');
        return;
      }

      const body = {
        quantity: 1,
        id: Number(variantId)
      };

      // TH 12/4/25 - thanks i hate this, but it's the fix we need given bandana bundle cart transformer requirements.
      if (ridProductItemId.includes('bandana')) {
        let guid = crypto.randomUUID();
        body.properties = {
          '_bandana-bundle-id': String(guid),
        };
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      
      if (!response.ok) {
        const responseJson = await response.json();
        
        document.documentElement.dispatchEvent(
          new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: "error",
              error: responseJson["description"] || `Failed to add item to cart.`,
            },
          })
        );
        return;
      }

      window.location.href = `/cart`;
    } catch (e) {
      console.error('RidProductItem: Error adding selected variant to cart', e);
    }
  }
};
window.customElements.define("rid-product-item", RidProductItem);


// js/custom-element/section/discount/notification.js
var DiscountNotification = class extends CustomHTMLElement {
  connectedCallback() {

    document.addEventListener("discount-notification:show", this._onShow.bind(this));

    this.delegate.on("click", '[data-action="close"]', (event) => {
      event.stopPropagation();
      this.hidden = true;
    });

    this.addEventListener("mouseenter", this.stopTimer.bind(this));
    this.addEventListener("mouseleave", this.startTimer.bind(this));
    window.addEventListener("pagehide", () => (this.hidden = true));
  }

  set hidden(value) {
    if (!value) {
      this.startTimer();
    } else {
      this.stopTimer();
    }
    this.toggleAttribute("hidden", value);
  }

  get isInsideDrawer() {
    return this.classList.contains("discount-notification--drawer");
  }

  stopTimer() {
    clearTimeout(this._timeout);
  }

  startTimer() {
    this._timeout = setTimeout(() => (this.hidden = true), 3000);
  }

  _onShow(event) {

    if (this.isInsideDrawer && !this.closest(".drawer")?.open) {
      console.warn("Drawer is closed. Notification not displayed.");
      return;
    }

    event.stopPropagation();

    let closeButtonHtml = "";
    if (!this.isInsideDrawer) {
      closeButtonHtml = `
        <button class="discount-notification__close tap-area" data-action="close" style="right: 24px !important;">
          <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>
          <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
            <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
          </svg>
        </button>
      `;
    }

    this.innerHTML = event.detail.status === "success"
      ? `<div class="discount-notification__wrapper heading heading--small">Success! Discount applied. ${closeButtonHtml}</div>`
      : `<div class="discount-notification__wrapper discount-notification--error heading heading--small">Error: ${event.detail.error} ${closeButtonHtml}</div>`;

    this.hidden = false;
  }

  showNotification(status = "success", error = "") {
    this._onShow({ detail: { status, error } });
  }
};

window.customElements.define("discount-notification", DiscountNotification);

// BEGIN FUNCTIONS FOR CART-UPSELL-DRAWER
function clearGroupActive(controlId, groupSelector) {
    const root = document.querySelector(`#${controlId}-drawer`);
    if (!root) return;
    const group = root.querySelector(groupSelector);
    if (!group) return;
    group.querySelectorAll('.button--filter.is-active').forEach((el) => el.classList.remove('is-active'));
    group.querySelectorAll('.button--filter').forEach((el) => (el.disabled = false));
  }

  // wrappers that toggle .is-active and call your existing functions as-is
  function onCategoryFilterClick(el, controlId, category) {
    clearGroupActive(controlId, '.badge-category-filters');
    el.classList.add('is-active');
    el.disabled = true;
    filterUpsellDrawerByCategory(controlId, category);
  }

  function onFinishFilterClick(el, controlId, finish) {
    clearGroupActive(controlId, '.finish-filters');
    el.classList.add('is-active');
    el.disabled = true;
    setProductItems(controlId, null, null, finish);
  }

  function onEmberFinishFilterClick(el, controlId, finish) {
    // run categoryFilterClick to 'Medical' first
    clearGroupActive(controlId, '.badge-category-filters');

    // add is-active to Medical category button if present
    const categoryButtons = document.querySelectorAll(`#${controlId}-drawer .badge-category-filters .button--filter`);
    categoryButtons.forEach((button) => {
      if (button.textContent.includes('Medical')) {
        button.classList.add('is-active');
        button.disabled = true;
      }
    });

    // then filter by Medical category
    filterUpsellDrawerByCategory(controlId, 'Medical');

    // then run finish filter logic
    clearGroupActive(controlId, '.finish-filters');
    el.classList.add('is-active');
    el.disabled = true;
    setProductItems(controlId, null, null, finish);
  }

  function onWidthFilterClick(el, controlId, width) {
    clearGroupActive(controlId, '.width-filters');
    el.classList.add('is-active');
    el.disabled = true;
    setProductItems(controlId, null, width, null);
  }

  function toggleCollapsibleContent(element) {
    var collapsibleContent = element.nextElementSibling;

    if (collapsibleContent && collapsibleContent.tagName === 'COLLAPSIBLE-CONTENT') {
      if (collapsibleContent.hasAttribute('open')) {
        collapsibleContent.removeAttribute('open');
      } else {
        collapsibleContent.setAttribute('open', '');
      }
    }
  }

  // Simple function to open drawer with pre-selected width
  function openUpsellDrawer(controlId, bundleId, width, finish) {
    // Open the drawer first
    const drawer = document.querySelector(`#${controlId}-drawer`);

    if (drawer) {
      drawer.setAttribute('open', '');

      // Pre-select width options after a small delay for content to load
      setTimeout(function () {
        setBuilderIdAttribute(controlId, bundleId);
        setProductItems(controlId, bundleId, width, finish);
      }, 150);
    }
  }

  function setBuilderIdAttribute(controlId, bundleId) {
    const addToCartButton = document.querySelector(`#${controlId}-upsell-add-to-cart`);
    if (addToCartButton) {
      addToCartButton.setAttribute('data-attribute-builder-id', bundleId);
    }
  }

  function setProductItems(controlId, bundleId, targetWidth, targetFinish) {
    const drawerContent = document.querySelector(`#${controlId}-drawer .drawer__content`);
    if (!drawerContent) {
      return;
    }

    // Find all option groups in the drawer
    const optionGroups = drawerContent.querySelectorAll('[data-option-title]');

    optionGroups.forEach(function (optionGroup) {
      const optionTitle = optionGroup.getAttribute('data-option-title');
      if (!optionTitle) return;

      const optionTitleLower = optionTitle.toLowerCase();

      // Check if this is a width/size option
      if (targetWidth) {
        if (optionTitleLower.includes('width') || optionTitleLower.includes('size')) {
          // Find radio inputs within this option group - these are what RidProductItem listens to
          const radioInputs = optionGroup.querySelectorAll('.block-swatch__radio');

          radioInputs.forEach(function (radioInput) {
            const radioValue = radioInput.value;

            // Check for exact match or partial match
            if (radioValue === targetWidth || radioValue.includes(targetWidth) || targetWidth.includes(radioValue)) {
              // Find the parent rid-product-item element
              const ridProductItem = radioInput.closest('rid-product-item');
              if (ridProductItem) {
                // Temporarily disable focus to prevent scrolling
                const originalFocus = radioInput.focus;
                radioInput.focus = function () {};

                // Trigger click event on the radio input
                const clickEvent = new Event('click', {
                  bubbles: true,
                  cancelable: true,
                });
                radioInput.dispatchEvent(clickEvent);

                // Restore original focus method after a brief delay
                setTimeout(function () {
                  radioInput.focus = originalFocus;
                }, 100);
              }
            }
          });
        }
      }

      // Check if this is a finish/color option
      if (targetFinish) {
        if (optionTitleLower.includes('finish') || optionTitleLower.includes('color')) {
          // Find radio inputs within this option group - these are what RidProductItem listens to
          const radioInputs = optionGroup.querySelectorAll('.color-swatch__radio');
          radioInputs.forEach(function (radioInput) {
            const radioValue = radioInput.value;

            // Check for exact match or partial match
            if (radioValue === targetFinish || radioValue.includes(targetFinish) || targetFinish.includes(radioValue)) {
              // Find the parent rid-product-item element
              const ridProductItem = radioInput.closest('rid-product-item');
              if (ridProductItem) {
                // Delay finish changes to let width changes settle first
                setTimeout(function () {
                  // Temporarily disable focus to prevent scrolling
                  const originalFocus = radioInput.focus;
                  radioInput.focus = function () {};

                  // Trigger click event on the radio input
                  const clickEvent = new Event('click', {
                    bubbles: true,
                    cancelable: true,
                  });
                  radioInput.dispatchEvent(clickEvent);

                  // Restore original focus method after a brief delay
                  setTimeout(function () {
                    radioInput.focus = originalFocus;
                  }, 100);
                }, 200); // 200ms delay to let width change complete
              }
            }
          });
        }
      }
    });
  }

  function filterUpsellDrawerByCategory(controlId, category) {
    const drawerContent = document.querySelector(`#${controlId}-drawer .drawer__content`);
    if (!drawerContent) {
      return;
    }

    const productItems = drawerContent.querySelectorAll('rid-product-item');

    productItems.forEach(function (productItem) {
      const badgeCategories = productItem.getAttribute('data-badge-categories');
      if (badgeCategories) {
        const categoriesArray = badgeCategories.split(',').map((cat) => cat.trim());
        if (categoriesArray.includes(category)) {
          productItem.style.display = 'flex'; // Show item
        } else {
          productItem.style.display = 'none'; // Hide item
        }
      }
    });
  }